(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtc-countdown-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yuna-sale-timer')) {
  customElements.define('yuna-sale-timer', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.deadline = Date.parse(this.dataset.end);
      this.clock = this.querySelector('.dtc-countdown__timer');
      if (!this.clock) return;
      if (!Number.isFinite(this.deadline)) { this.clock.hidden = true; return; }
      this.update = () => {
        const seconds = Math.ceil((((this.deadline - Date.now()) % 43200000 + 43200000) % 43200000 || 43200000) / 1000);
        const values = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60];
        ['hours', 'minutes', 'seconds'].forEach((unit, i) => {
          this.querySelector('[data-' + unit + ']').textContent = String(values[i]).padStart(2, '0');
        });
        if (!seconds) {
          this.clock.hidden = true;
          if (this.dataset.expired) this.querySelector('.dtc-countdown__message').textContent = this.dataset.expired;
          this.stop();
        }
      };
      this.onVisibility = () => { if (!document.hidden) this.update(); };
      this.interval = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.update();
    }
    stop() {
      clearInterval(this.interval);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
    }
    disconnectedCallback() { this.stop(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-header"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.yuna-header__mobile-menu').forEach((menu)=>{menu.querySelector('[data-yuna-close]')?.addEventListener('click',()=>menu.removeAttribute('open'));menu.addEventListener('click',(event)=>{if(event.target===menu)menu.removeAttribute('open')})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
